import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './TakeoutMakeComment.less';

export default class TakeoutMakeComment extends OfficialPage {
  state = {
    goodsInfo: [],
    submitData: {
      order_id: '',
      goods: [],
      takeout_score: 5,
      takeout_serve_score: 5
    },
    isShowTextArea: true
  }

  constructor(props) {
    super(props);
    document.title = '评价';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.setData({
      'submitData.order_id': options.detail || '',
      'submitData.sub_shop_app_id': options.franchisee || ''
    })
    this.getOrderDetail()
  }

  getOrderDetail = () => {
    var that = this
    app.getOrderDetail({
      data: {
        order_id: that.data.submitData.order_id,
        sub_shop_app_id: this.data.submitData.sub_shop_app_id
      },
      success: function (res) {
        var goodsInfo = res.data[0].form_data.goods_info,
          is_dining = res.data[0].form_data.is_dining == 1 ? true : false,
          goods = []
        for (var i = 0, j = goodsInfo.length - 1; i <= j; i++) {
          goods.push({
            goods_id: goodsInfo[i].goods_id,
            info: {
              content: '',
              level: 1,
              img_arr: []
            }
          })
        }
        that.setData({
          takeoutInfo: res.data[0].take_out_info,
          is_dining: is_dining,
          goodsInfo: goodsInfo,
          'submitData.goods': goods
        })
      }
    })
  }
  setDescScore = e => {
    var score = e.target.dataset.score
    this.setData({
      'submitData.takeout_score': score
    })
  }
  setScore = e => {
    var score = e.target.dataset.score
    this.setData({
      'submitData.takeout_serve_score': score
    })
  }
  setGoodsScore = e => {
    var goodsIndex = e.currentTarget.dataset.goodsIndex,
      score = e.currentTarget.dataset.score,
      data = {}
    data['submitData.goods[' + goodsIndex + '].info.level'] = score
    this.setData(data)
  }
  commentInput = e => {
    var goodsIndex = e.target.dataset.goodsIndex,
      data = {}
    data['submitData.goods[' + goodsIndex + '].info.content'] = e.target.value
    this.setData(data)
  }
  chooseImage = e => {
    var that = this,
      goodsIndex = e.currentTarget.dataset.goodsIndex,
      img_arr = that.data.submitData.goods[goodsIndex].info.img_arr
    if (img_arr.length >= 3) {
      app.showModal({
        content: '每个商品最多上传3张图片'
      })
      return
    }
    app.chooseImage(function (images) {
      var data = {}
      data[
        'submitData.goods[' + goodsIndex + '].info.img_arr'
      ] = img_arr.concat(images)
      that.setData(data)
    }, 3 - img_arr.length)
  }
  removePic = e => {
    var goodsIndex = e.currentTarget.dataset.goodsIndex,
      picIndex = e.currentTarget.dataset.picIndex,
      img_arr = this.data.submitData.goods[goodsIndex].info.img_arr,
      data = {}
    img_arr.splice(picIndex, 1)
    data['submitData.goods[' + goodsIndex + '].info.img_arr'] = img_arr
    this.setData(data)
  }
  makeComment = () => {
    var that = this,
      submitData = that.data.submitData,
      modalText = ''
    for (var i = submitData.goods.length - 1; i >= 0; i--) {
      var goods = submitData.goods[i]
      if (!goods.info.level) {
        modalText = '尚未给商品评分'
        break
      }
      if (goods.info.img_arr.length > 3) {
        modalText = '每个商品最多上传3张图片'
        break
      }
    }
    if (modalText) {
      app.showModal({
        content: modalText
      })
      return
    }
    let addTime = Date.now()
    for (let i = 0; i < submitData.goods.length; i++) {
      if (
        submitData.goods[i].info.level > 2 &&
        submitData.goods[i].info.level < 5
      ) {
        submitData.goods[i].info.level = 2
      } else if (submitData.goods[i].info.level > 4) {
        submitData.goods[i].info.level = 3
      }
    }
    app.sendRequest({
      url: '/index.php?r=AppShop/AddAssessList',
      method: 'post',
      data: submitData,
      success: function (res) {
        app.sendRequest({
          hideLoading: true,
          url: '/index.php?r=appShop/getIntegralLog',
          data: { add_time: addTime },
          success: function (res) {
            if (res.data == 0) {
              app.showModal({
                content: '评论成功',
                confirm: function () {
                  app.turnBack()
                }
              })
            } else {
              that.setData({
                isShowTextArea: false,
                rewardPointObj: {
                  showModal: true,
                  count: res.data,
                  callback: 'turnBack'
                }
              })
            }
          }
        })
      }
    })
  }

  render() {
    const {
      rewardPointObj,
      shareGiftsObj,
      collectGiftsObj,
      collectGetObj,
      showGetUserInfo,
      takeoutInfo,
      goodsInfo,
      submitData,
      isShowTextArea
    } = this.state

    return (
      <div className="official-page takeout-make-comment">
        <TopNav title="评价"/>
        <React.Fragment>
          <div className="makeCom-wrap page" id="makeComment">
            <div className="takeoutTitle">
              <img src={takeoutInfo && takeoutInfo.cover} />
              <span>{takeoutInfo && takeoutInfo.title}</span>
            </div>
            <div
              className="takeoutEvaluate"
              style={convertLineStyleData('height: 80rpx;margin-top: 16rpx;line-height: 80rpx;padding: 0 30rpx;background-color: #fff;border-bottom: 1px solid #f3f3f3;font-size: 28rpx;')}
            >
              商品评价
            </div>
            <div style={convertLineStyleData('background-color: #fff;')}>
              {goodsInfo.map((item, goodsIndex) => {
                return (
                  <div className="makeCom-item makeCom-goods-comment" key={goodsIndex}>
                    <div style={convertLineStyleData('padding:0 0 30rpx;font-size: 32rpx;word-break: break-all;')}>
                      {item.goods_name}
                      <div
                        className="makeCommentLeval pull-right"
                        style={convertLineStyleData('color:#dcdcdc')}
                      >
                        <span
                          className="ico-moon icon-fullstar"
                          onClick={this.setGoodsScore}
                          data-score="5"
                          data-goods-index={goodsIndex}
                          style={convertLineStyleData(
                            submitData.goods[goodsIndex].info.level <= 5
                              ? 'color:#fc9e20;'
                              : 'color:#dcdcdc;'
                          )}
                        ></span>
                        <span
                          className="ico-moon icon-fullstar"
                          onClick={this.setGoodsScore}
                          data-score="4"
                          data-goods-index={goodsIndex}
                          style={convertLineStyleData(
                            submitData.goods[goodsIndex].info.level <= 4
                              ? 'color:#fc9e20;'
                              : 'color:#dcdcdc;'
                          )}
                        ></span>
                        <span
                          className="ico-moon icon-fullstar"
                          onClick={this.setGoodsScore}
                          data-score="3"
                          data-goods-index={goodsIndex}
                          style={convertLineStyleData(
                            submitData.goods[goodsIndex].info.level <= 3
                              ? 'color:#fc9e20;'
                              : 'color:#dcdcdc;'
                          )}
                        ></span>
                        <span
                          className="ico-moon icon-fullstar"
                          onClick={this.setGoodsScore}
                          data-score="2"
                          data-goods-index={goodsIndex}
                          style={convertLineStyleData(
                            submitData.goods[goodsIndex].info.level <= 2
                              ? 'color:#fc9e20;'
                              : 'color:#dcdcdc;'
                          )}
                        ></span>
                        <span
                          className="ico-moon icon-fullstar"
                          onClick={this.setGoodsScore}
                          data-score="1"
                          data-goods-index={goodsIndex}
                          style={convertLineStyleData(
                            submitData.goods[goodsIndex].info.level == 1
                              ? 'color:#fc9e20;'
                              : 'color:#dcdcdc;'
                          )}
                        ></span>
                      </div>
                      <div style={convertLineStyleData('font-size:24rpx;color:#666;')}></div>
                    </div>
                    <div>
                      {isShowTextArea && (
                        <textarea
                          data-goods-index={goodsIndex}
                          onInput={this.commentInput}
                          className="makeCom-textarea"
                          placeholder="说说哪里满意，来帮助大家选择"
                        ></textarea>
                      )}
                    </div>
                    <div className="makeCom-pic-container">
                      {submitData.goods[goodsIndex].info.img_arr.map(
                        (imgUrl, index) => {
                          return (
                            <div key={index} className="makeCom-pic-wrap">
                              <img src={imgUrl} mode="aspectFit" />
                              <label
                                className="makeCom-remove-pic"
                                onClick={this.removePic}
                                data-goods-index={goodsIndex}
                                data-pic-index={index}
                              >
                                ×
                              </label>
                            </div>
                          )
                        }
                      )}
                      {submitData.goods[goodsIndex].info.img_arr.length < 3 && (
                        <div
                          className="makeCom-upload-pic"
                          onClick={this.chooseImage}
                          data-goods-index={goodsIndex}
                        >
                          <div
                            className="ico-moon icon-addassessimg"
                            style={convertLineStyleData('display:block; font-size: 60rpx;')}
                          ></div>
                          <span>添加图片</span>
                        </div>
                      )}
                    </div>
                  </div>
                )
              })}
            </div>
            <div
              className="makeCom-item"
              style={convertLineStyleData('padding:0;line-height:30px;margin: 16rpx 0 0;border-bottom: none;')}
            >
              <div style={convertLineStyleData('font-size:28rpx; height:80rpx;line-height:80rpx;padding: 0 30rpx;')}>
                评价商家服务
              </div>
              <div style={convertLineStyleData('font-size: 32rpx; height:80rpx;line-height:80rpx;padding: 0 30rpx')}>
                服务态度：
                <div
                  className="makeCommentLeval pull-right"
                  style={convertLineStyleData('color:#dcdcdc')}
                >
                  <span
                    className="ico-moon icon-fullstar"
                    style={convertLineStyleData(
                      submitData.takeout_serve_score >= 1
                        ? 'color:#fc9e20;'
                        : 'color:#dcdcdc;'
                    )}
                    onClick={this.setScore}
                    data-score="1"
                  ></span>
                  <span
                    className="ico-moon icon-fullstar"
                    style={convertLineStyleData(
                      submitData.takeout_serve_score >= 2
                        ? 'color:#fc9e20;'
                        : 'color:#dcdcdc;'
                    )}
                    onClick={this.setScore}
                    data-score="2"
                  ></span>
                  <span
                    className="ico-moon icon-fullstar"
                    style={convertLineStyleData(
                      submitData.takeout_serve_score >= 3
                        ? 'color:#fc9e20;'
                        : 'color:#dcdcdc;'
                    )}
                    onClick={this.setScore}
                    data-score="3"
                  ></span>
                  <span
                    className="ico-moon icon-fullstar"
                    style={convertLineStyleData(
                      submitData.takeout_serve_score >= 4
                        ? 'color:#fc9e20;'
                        : 'color:#dcdcdc;'
                    )}
                    onClick={this.setScore}
                    data-score="4"
                  ></span>
                  <span
                    className="ico-moon icon-fullstar"
                    style={convertLineStyleData(
                      submitData.takeout_serve_score >= 5
                        ? 'color:#fc9e20;'
                        : 'color:#dcdcdc;'
                    )}
                    onClick={this.setScore}
                    data-score="5"
                  ></span>
                </div>
              </div>
              <div style={convertLineStyleData('font-size: 32rpx; height:80rpx;line-height:80rpx;padding: 0 30rpx')}>
                配送服务：
                <div
                  className="makeCommentLeval pull-right"
                  style={convertLineStyleData('color:#dcdcdc')}
                >
                  <span
                    className="ico-moon icon-fullstar"
                    style={convertLineStyleData(
                      submitData.takeout_score >= 1
                        ? 'color:#fc9e20;'
                        : 'color:#dcdcdc;'
                    )}
                    onClick={this.setDescScore}
                    data-score="1"
                  ></span>
                  <span
                    className="ico-moon icon-fullstar"
                    style={convertLineStyleData(
                      submitData.takeout_score >= 2
                        ? 'color:#fc9e20;'
                        : 'color:#dcdcdc;'
                    )}
                    onClick={this.setDescScore}
                    data-score="2"
                  ></span>
                  <span
                    className="ico-moon icon-fullstar"
                    style={convertLineStyleData(
                      submitData.takeout_score >= 3
                        ? 'color:#fc9e20;'
                        : 'color:#dcdcdc;'
                    )}
                    onClick={this.setDescScore}
                    data-score="3"
                  ></span>
                  <span
                    className="ico-moon icon-fullstar"
                    style={convertLineStyleData(
                      submitData.takeout_score >= 4
                        ? 'color:#fc9e20;'
                        : 'color:#dcdcdc;'
                    )}
                    onClick={this.setDescScore}
                    data-score="4"
                  ></span>
                  <span
                    className="ico-moon icon-fullstar"
                    style={convertLineStyleData(
                      submitData.takeout_score >= 5
                        ? 'color:#fc9e20;'
                        : 'color:#dcdcdc;'
                    )}
                    onClick={this.setDescScore}
                    data-score="5"
                  ></span>
                </div>
              </div>
            </div>
            <div className="makeCom-bottom-nav" onClick={this.makeComment}>
              <label className="makeCom-make-comment btn btn-orange">
                发表评价
              </label>
            </div>
          </div>
        </React.Fragment>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/takeout-make-comment/TakeoutMakeComment.jsx